module.exports = __webpack_public_path__ + "img/image_ot-peru-eten_tanks_1920px.cd866be7.jpg";